import type {
  Alliance,
  AllianceState,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/alliances';

export const get = (state: AllianceState, id: number): Alliance | undefined => state.byId[id];
export const all = (state: AllianceState): Record<number, Alliance> => state.byId;
